<template>
  <div
    class="block-wrap block-specification"
    style="padding:10px">
    <div
      v-for="(s, sindex) in specifications"
      :key="s.nameKey">
      <div :class="['title-bg', {'input-bg': !canNoteItems.length}]">
        规格名：
        <template>
          <el-select
            v-if="!canNoteItems.length"
            v-model="s.name"
            width="140px"
            :loading="selectLoading"
            @change="changeSelectSpecName"
            @visible-change="visibleChangeSelect"
          >
            <el-option
              v-for="op in specOptions"
              :key="op.parentSpecId"
              :value="op.parentSpecName"
              :label="op.parentSpecName"
            ></el-option>
          </el-select>
          <el-input v-else :disabled="!!canNoteItems.length" style="width:140px" v-model="s.name" :maxlength="20"></el-input>
        </template>
      </div>
      <div class="specification-value">
        <div style="display: inline-block; padding-top: 7px; padding-left:10px;">规格值：</div>
        <vue-draggable class="specification-value-flex" v-model="specifications[sindex].values" handle=".drag-icon-wrap" :group="{ name: s.nameKey, pull: 'clone', put: false }" :animation="500">
          <div
            v-for="(v, vi) in specifications[sindex].values"
            :key="`${v.valueKey}`"
            class="specification-value-flex_item">
            <div class="del-input-wrap">
              <template v-if="canNoteItems.length">
                  <el-select 
                    :value="v.value"
                    @change="handleSelect($event, sindex, v, vi)"
                    placeholder="请选择"
                    filterable
                    allow-create
                    default-first-option
                  >
                    <template v-if="sindex === 0">
                      <el-option-group
                        v-for="group in options[v.refPid]"
                        :key="group.label"
                        :label="group.label">
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.value"
                          :value="item.value">
                        </el-option>
                      </el-option-group>
                    </template>
                    <template v-else>
                      <el-option
                        v-for="(op, opidx) in options[v.refPid]"
                        :key="`${sindex}-${vi}-${opidx}`"
                        :label="op.value"
                        :value="op.value"
                      ></el-option>
                    </template>
                  </el-select>
                <el-input
                  class="input-remark"
                  :ref="`${sindex}-${vi}-remark`"
                  placeholder="备注"
                  @input="remarkInput"
                  v-model="v.note"></el-input>
              </template>
              <template v-else>
                  <el-input
                    :ref="`${sindex}-${vi}`"
                    @blur="(e) => blurHandle(sindex, vi, e)" class="specification-value-flex_input"
                    @keyup.enter.native="(e) => valueEnter(sindex, vi)"
                    @input="(e) => valueInput(v)"
                    v-model="v.value"></el-input>
              </template>
              <el-checkbox
                style="margin-left: 8px"
                v-model="v.checked"
                @change="onChangeCheckbox"
                :disabled="v.checked && specifications[sindex].values.filter(item => item.checked).length === 1"></el-checkbox>
              <drag-item-content></drag-item-content>
            </div>
            <div v-if="sindex === 0" class="specification-value-flex_img">
              <ImgUpload
                :width="80"
                :height="80"
                :file="v.imageUrl"
                @upload-success="(url) => imageUploadSuccess(url, v)"
                @del="() => imageUploadDel(v)"
                :limitSuffix="imgLimitSuffix"
                :isSingle="true"
              />
            </div>
          </div>
        </vue-draggable>
      </div>
    </div>
  </div>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload'
import { dragItemMixin } from '@/components/prod/center/utils/mixins'

export default {
  components: {
    ImgUpload,
  },
  model: {
    prop: 'values',
    event: 'change'
  },
  mixins: [dragItemMixin],
  props: {
    values: {
      type: Array,
      default() {
        return []
      }
    },
    imgLimitSuffix: { // 图片类型限制
      type: String,
      default: '.jpg,.jpeg,.png,.gif'
    },
    shopId: {// pdd店铺id， pdd规格下拉框切换值时需要获取pdd平台的规格id
      type: Number,
    },
    isPdd: {
      type: Boolean,
      default: false
    },
    sizeType: {// 规格类型
      type: Number,
      default: 1
    },
    getPddSpecList: {
      type: Function
    },
    canNoteItems: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      specifications: [],
      specOptions: [], // 规格名下拉框列表项
      selectLoading: false, // 规格名下拉框loading
      options: {}
    }
  },
  watch: {
    values:{
      handler(v) {
        this.specifications = v;
      },
      immediate: true
    },
    sizeType: {
      handler() {
        this.computeOptions();
        this.computeSpec();
      },
      immediate: true
    },
    canNoteItems: {
      handler() {
        this.computeOptions(true);
        this.computeSpec();
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.getPddSpecList().then(list => {
        this.specOptions = list;
      })
  },
  methods: {
    computeOptions(isInitial) {
      const res = {};
      this.canNoteItems.forEach((item, idx) => {
        if (idx === 1 || item.name === '尺码') {
          // const values = (item.values || []).filter(v => String(v.group && v.group.id) === String(this.sizeType));
          res[item.refPid] = (item.values || []).filter(v => {
            if (v.group) {
              return String(v.group.id) === String(this.sizeType)
            }
            return true;
          })
        } else {
          res[item.refPid] = isInitial ? this.groupSpec((item.values || []).slice(0)) : this.options[item.refPid];
        }
      })
      this.options = res;
    },
    // 尺码-spcId初始和下拉框列表匹配
    computeSpec() {
      for (let [idx, spec] of this.specifications.entries()) {
        if (idx === 0) continue;
        spec.values.forEach(v => {
            if (!v.specId) {
              const ops = this.options[v.refPid];
              if (ops) {
                const idx = ops.findIndex(op => op.value === v.value);
                if (idx !== -1) {
                  v.specId = ops[idx].specId;
                  v.vid = ops[idx].vid;
                  v.groupId = ops[idx].group && ops[idx].group.id;
                }
              }
            }
          })
      }
    },
    // 颜色信息分组
    groupSpec(values) {
      const groups = values.reduce((acc, v) => {
        if (v.group) {
          if (!acc[v.group.name]) acc[v.group.name] = [];
          acc[v.group.name].push(v);
        } else {
          if (!acc['其他']) acc['其他'] = [];
          acc['其他'].push(v);
        }
        return acc;
      }, {});
      const options = [];
      for (let key in groups) {
        options.push({
          label: key,
          options: groups[key]
        })
      }
      return options;
    },
    onChangeCheckbox() {
      window.__spcificationCheckbox_changed = true;
    },
    remarkInput() {
      window.__spcificationCheckbox_changed = true;
    },
    querySearch(v, str, cb) {
      cb(this.options[v.refPid] || []);
    },
    getItemByOptins(val, refPid) {
      let item = null;
      let options = this.options[refPid];
      if (options && options[0] && options[0].options) {
        options = options.reduce((acc, op) => {
          acc = acc.concat(op.options);
          return acc;
        }, []);
      }
      const idx = options.findIndex(it => it.value === val);
      if (idx !== -1) {
        item = options[idx];
      }
      return item;
    },
    async handleSelect(val, sindex, v, vi) {
      let item = this.getItemByOptins(val, v.refPid);
      let value = {};
      if (!item) {
        value = {
          ...v,
          value: val,
          specId: '',
          valueKey: v.valueKey
        }
      } else {
        v.value = val;
        this.isSelect = true;
        if (this.isSame(this.specifications[sindex].values, item.value, vi)) {
          this.$message.error('请勿选择相同规格值');
          return;
        }
        value = {
          ...v,
          ...item,
          groupId: (item.group && item.group.id) || '',
          valueKey: v.valueKey,
        }
        this.isSelect = false;
      }
      // window.__spcificationCheckbox_changed = true;
      this.specifications[sindex].values[vi] = value;
      this.$emit("change", JSON.parse(JSON.stringify(this.specifications)))
    },
    isSame(values, value, idx) {
      let flag = false;
      values.forEach((item, i) => {
        if (i !== idx && item.value === value) {
          flag = true;
        }
      });
      return flag;
    },
    // 规格值回车事件
    valueEnter(sindex, vindex) {
      let nextInputVm = this.$refs[`${sindex}-${vindex + 1}`]
      nextInputVm = nextInputVm ? nextInputVm[0] : nextInputVm
      if (nextInputVm) {
        // 聚焦到下一个
        nextInputVm.focus()
      }
    },
    // 规格值输入事件
    blurHandle(sindex, vi, e) {
      if (this.isSelect) return;
      const _value = e.target.value
      if (!_value) return this.$message.error('请填写规格值')
      const values = this.specifications[sindex].values
      let isSame = false
      values.forEach((item, i) => {
        if (vi !== i && item.value === e.target.value) {
          isSame = true
        }
      })
      if (isSame) { 
        this.$message.error('请勿输入相同规格值')
      }
    },
    valueInput(v) {
      window.__spcificationImg_changed = v.valueKey // 用于skuList生成时的图片取值规则
    },
    imageUploadSuccess(url, v) {
      v.imageUrl = url;
      this.$emit("change", JSON.parse(JSON.stringify(this.specifications)))
      window.__spcificationImg_changed = v.valueKey // 用于skuList生成时的图片取值规则
    },
    imageUploadDel(v) {
      v.imageUrl = '';
      this.$emit("change", JSON.parse(JSON.stringify(this.specifications)))
      window.__spcificationImg_changed = v.valueKey // 用于skuList生成时的图片取值规则
    },
    async visibleChangeSelect() {
      if (this.specOptions?.length) return;
      this.selectLoading = true;
      const list = await this.getPddSpecList();
      this.specOptions = list;
      this.selectLoading = false;
    },
    changeSelectSpecName() {
      window.__spcificationCheckbox_changed = true;
    },
    getParentSpecId(name) {
      if (!this.isPdd) return; // pdd 修改规格值重新获取propValueId
      const specOptions = this.specOptions;
      if (!specOptions) return;
      const idx = specOptions.findIndex(option => option.parentSpecName === name);
      if (idx !== -1) {
        const item = specOptions[idx];
        return item.parentSpecId
      }
      return '';
    },
    validate(specifications) {
      specifications = specifications || this.specifications;
      for(let [idx, spec] of specifications.entries()) {
        if (idx > 0) {
          for (let v of spec.values) {
              if (!v.specId) {
                  this.$message.error(`规格【${spec.name}】的规格值【${v.value}】下拉列表中不存在，请重新修改替换！`)
                  return;
              }
              const op = this.options[v.refPid];
              // if (op && v.checked) {
              //   const idx = op.findIndex(opItem => opItem.value === v.value);
              //   if (idx === -1) {
              //     this.$message.error(`规格【${spec.name}】的规格值【${v.value}】下拉列表中不存在，请重新修改替换！`)
              //     return false;
              //   }
              // }
          }
        }
      }
      return true;
    }
  }
}
</script>

<style lang="scss" scoped>
.block-wrap {
  border: 1px solid #DCDFE6;
  
  .input-value {
    display: inline-block;
  }
  .add-sku-tips {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 2px;
    padding: 5px 10px;
    font-size: 12px;
    margin-top: 10px;
  }
  .tips-btn {
    cursor: pointer;
  }
}
.title-bg {
  background: #f8f8f8;
  padding: 7px 10px;
  ::v-deep .el-input input {
    background: #F8F8F8 !important;
  }
}
.input-bg {
  ::v-deep .el-input input {
    background: #FFFFFF !important;
  }
}

.specification-value {
  &-flex {
    display: inline-flex;
    flex-wrap: wrap;
    width: 90%;
    &_item {
      margin-right: 10px;
      margin-bottom: 10px;
    }
    &_img {
      width: 82px;
      height: 82px;
      margin-top: 10px;
      position: relative;
    }
    .el-input {
      width: 160px;
    }
  }
}
.del-input-wrap {
  position: relative;
  padding-right: 10px;
  &:hover {
    .del-btn {
      display: flex;
    }
  }
  .del-btn {
    cursor: pointer;
    display: none;
    position: absolute;
    color: #fff;
    font-size: 12px;
    background-color: rgba(0,0,0,.3);
    justify-content: center;
    align-items: center;
  }
  .del-btn {
    width: 18px;
    height: 18px;
    top: 0;
    right: 0;
    border-radius: 50%;
    transform: translate(45%, -45%);
  }
  .input-remark {
    margin-left: 10px;
  }
}
.block-specification {
  max-height: 444px;
  overflow-y: auto;
}
</style>